export default __webpack_public_path__ + "static/media/brain-icon-color.38a27c1f.svg";